(function () {
  var UNLOCK_KEY = 'hwGhostHuntUnlockV1';

  function isUnlocked() {
    try { return sessionStorage.getItem(UNLOCK_KEY) === 'CRIANCAS'; } catch (e) { return false; }
  }

  function applyLockState() {
    var on = isUnlocked() || document.documentElement.classList.contains('ddc-unlocked');
    if (on) document.documentElement.classList.add('ddc-unlocked');
    document.querySelectorAll('[data-ddc-secret]').forEach(function (el) {
      el.hidden = !on;
      el.classList.toggle('is-revealed', on);
    });
    document.querySelectorAll('[data-ddc-teaser]').forEach(function (el) {
      el.hidden = !!on;
    });
  }

  window.ddcIsUnlocked = isUnlocked;
  window.ddcUnlock = function () {
    try { sessionStorage.setItem(UNLOCK_KEY, 'CRIANCAS'); } catch (e) {}
    document.documentElement.classList.add('ddc-unlocked');
    applyLockState();
    document.dispatchEvent(new CustomEvent('ddc:unlocked'));
  };
  window.ddcApplyLock = applyLockState;
  applyLockState();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyLockState);
  }

  var FALLBACK_END = '2026-10-12T23:59:59-03:00';

  function pad2(value) {
    return String(Math.max(0, Math.floor(value))).padStart(2, '0');
  }

  function pad3(value) {
    return String(Math.max(0, Math.floor(value))).padStart(3, '0');
  }

  function getEndMs(root) {
    var iso = root.getAttribute('data-end');
    if (iso) {
      var parsed = Date.parse(iso);
      if (!Number.isNaN(parsed)) return parsed;
    }

    var month = parseInt(root.getAttribute('data-end-month'), 10);
    var day = parseInt(root.getAttribute('data-end-day'), 10);
    var hour = parseInt(root.getAttribute('data-end-hour'), 10);
    var minute = parseInt(root.getAttribute('data-end-minute'), 10);
    var second = parseInt(root.getAttribute('data-end-second'), 10);
    if (month && day) {
      var endDate = new Date(2026, month - 1, day, hour || 0, minute || 0, second || 0, 999);
      if (!Number.isNaN(endDate.getTime())) return endDate.getTime();
    }

    return Date.parse(FALLBACK_END);
  }

  function tick(root) {
    var daysEl = root.querySelector('[data-match-days]');
    var hoursEl = root.querySelector('[data-match-hours]');
    var minutesEl = root.querySelector('[data-match-minutes]');
    var secondsEl = root.querySelector('[data-match-seconds]');
    var msEl = root.querySelector('[data-match-milliseconds]');
    if (!daysEl || !hoursEl || !minutesEl || !secondsEl) return;

    var rem = getEndMs(root) - Date.now();
    if (rem < 0) rem = 0;

    var dayMs = 24 * 60 * 60 * 1000;
    var hourMs = 60 * 60 * 1000;
    var minuteMs = 60 * 1000;

    daysEl.textContent = pad2(rem / dayMs);
    hoursEl.textContent = pad2((rem % dayMs) / hourMs);
    minutesEl.textContent = pad2((rem % hourMs) / minuteMs);
    secondsEl.textContent = pad2((rem % minuteMs) / 1000);
    if (msEl) msEl.textContent = pad3(rem % 1000);
  }

  function tickAll() {
    document.querySelectorAll('[data-match-countdown]').forEach(tick);
  }

  tickAll();
  window.setInterval(tickAll, 50);

  if (window.__sazonalBarBound) return;
  window.__sazonalBarBound = true;

  function fallbackCopy(text, done) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'absolute';
    ta.style.left = '-9999px';
    document.body.appendChild(ta);
    ta.select();
    try { document.execCommand('copy'); } catch (e) {}
    document.body.removeChild(ta);
    done();
  }

  function copyCode(text, done) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(done).catch(function () {
        fallbackCopy(text, done);
      });
      return;
    }
    fallbackCopy(text, done);
  }

  document.addEventListener('click', function (event) {
    var star = event.target.closest('[data-sazonal-star]');
    if (star) {
      star.classList.remove('is-popped');
      void star.offsetWidth;
      star.classList.add('is-popped');
      window.setTimeout(function () {
        star.classList.remove('is-popped');
      }, 450);
      return;
    }

    var btn = event.target.closest('[data-sazonal-copy]');
    if (!btn) return;
    var code = btn.getAttribute('data-sazonal-copy') || 'CRIANCAS';
    var original = btn.getAttribute('data-original') || btn.textContent.trim();
    btn.setAttribute('data-original', original);
    copyCode(code, function () {
      btn.classList.add('is-copied');
      btn.textContent = 'Copiado!';
      window.setTimeout(function () {
        btn.classList.remove('is-copied');
        btn.textContent = original;
      }, 1500);
    });
  });
})();
